<template>
  <div>
    <v-btn v-on:click="pickFile"
           class="mx-3 primary onPrimary--text btnAnimation"
           :loading="loading"
    >
      <v-icon left>attach_file</v-icon>
      Adjuntar comprobante
    </v-btn>

    <input type="file"
           style="display: none"
           ref="file"
           :accept="accept"
           @change="onFilePicked"
    />
    <v-alert dense type="error" class="ma-2" v-if="showError">
      {{ errorMessage }}
    </v-alert>

  </div>
</template>

<script>
import {UploadProvider} from "@dracul/media-frontend";
import {ClientError} from '@dracul/common-frontend'




export default {
  name: "UploadReceipt",
  props: {
    autoSubmit: {type: Boolean, default: false},
    accept: {type: String, default: '*'},
    xLarge: {type: Boolean, default: false},
  },
  data() {
    return {
      showError: false,
      errorMessage: '',
      inputErrors: {},
      file: null,
      uploadedFile: null,
      loading: false,
    }
  },
  computed: {
    getSrc() {
      if (this.uploadedFile && this.uploadedFile.url) {
        return this.uploadedFile.url
      }
      return null
    }
  },
  methods: {
    pickFile() {
      this.file = null
      this.showError = false
      this.errorMessage = ''
      this.$refs.file.value = ''
      this.$refs.file.click()
    },
    onFilePicked: function (e) {
      this.file = e.target.files[0]
      this.upload()
    },
    upload() {
      if (this.file) {
        this.loading = true
        UploadProvider.uploadFileAnonymous(this.file)
            .then(result => {
              this.uploadedFile = result.data.fileUploadAnonymous
              this.$emit('fileUploaded', result.data.fileUploadAnonymous)
            })
            .catch(err => {
              let clientError = new ClientError(err)
              this.errorMessage = clientError.i18nMessage ? this.$t(clientError.i18nMessage) : clientError.message
              this.showError = true
            })
            .finally(() => this.loading = false)
      }
    }
  }
}
</script>

<style scoped>
.btnAnimation {
  animation: signal 1s infinite;
}

@keyframes signal {
  0% {
    box-shadow: 0 0 0 0 #242528
  }
  100% {
    box-shadow: 0 0 0 25px rgba(0, 0, 0, 0)
  }
}
</style>
